export default __webpack_public_path__ + "static/media/telescope.d78456dd.svg";